import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../Utils/api";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


function GruposAcessoEmpresasModal({ show, handleClose, idEmpresa, nomeEmpresa, idEntidade }) {
  const { toast } = useFeedback();
  const [grupos, setGrupos] = useState([]);
  const [selecionados, setSelecionados] = useState(new Set());
  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (!show || !idEmpresa || !idEntidade) return;
    setCarregando(true);
    fetch(
      `${BASE_URL}/api/empresas/GruposComAcessoEmpresa/${idEntidade}/${idEmpresa}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then((r) => r.json())
      .then((data) => {
        const lista = data.data || [];
        const gruposComAcesso = lista.filter((g) => g.tem_acesso).map((g) => g.id);
        setGrupos(lista);
        setSelecionados(new Set(gruposComAcesso.length > 0 ? gruposComAcesso : lista.map((g) => g.id)));
      })
      .catch(() => setGrupos([]))
      .finally(() => setCarregando(false));
  }, [show, idEmpresa, idEntidade, token]);

  const toggleGrupo = (id) => {
    setSelecionados((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleTodos = () => {
    if (selecionados.size === grupos.length) {
      setSelecionados(new Set());
    } else {
      setSelecionados(new Set(grupos.map((g) => g.id)));
    }
  };

  const handleSalvar = async () => {
    setSalvando(true);
    try {
      const resp = await fetch(
        `${BASE_URL}/api/empresas/SalvarAcessoEmpresaGrupos/${idEmpresa}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ gruposComAcesso: Array.from(selecionados) }),
        }
      );
      if (!resp.ok) throw new Error("Erro ao salvar");
      handleClose();
    } catch (err) {
      toast.error(err.message || "Erro ao salvar acesso dos grupos.");
    } finally {
      setSalvando(false);
    }
  };

  const todosSelecionados = grupos.length > 0 && selecionados.size === grupos.length;
  const algumSelecionado = selecionados.size > 0 && selecionados.size < grupos.length;

  const estiloCard = {
    background: "var(--surface-sunken)",
    border: "1px solid var(--border-default)",
    borderRadius: 8,
    padding: "10px 14px",
    marginBottom: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  };

  const estiloNome = {
    fontSize: "0.9rem",
    color: "var(--text-body)",
    fontWeight: 500,
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered backdrop="static">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          Acesso por Grupo de Usuário
          {nomeEmpresa && (
            <span style={{ display: "block", fontSize: "0.78rem", fontWeight: 400, color: "var(--text-muted)", marginTop: 2 }}>
              Empresa: <strong>{nomeEmpresa}</strong>
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        {carregando ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" />
            <span className="ms-2">Carregando grupos...</span>
          </div>
        ) : grupos.length === 0 ? (
          <p className="text-muted text-center py-3" style={{ fontSize: "0.875rem" }}>
            Nenhum grupo de usuário encontrado para esta entidade.
          </p>
        ) : (
          <>
            <div style={{ marginBottom: 12 }}>
              <p style={{ fontSize: "0.82rem", color: "var(--text-muted)", margin: 0 }}>
                {"Ao salvar, todos os grupos selecionados ser\u00e3o vinculados por padr\u00e3o. "}
                <strong>{"Caso um grupo n\u00e3o possa acessar documentos desta empresa, desmarque-o."}</strong>
              </p>
            </div>

            <div
              style={{ ...estiloCard, marginBottom: 14, borderStyle: "dashed", cursor: "pointer" }}
              onClick={toggleTodos}
            >
              <span style={{ ...estiloNome, color: "var(--text-muted)", fontWeight: 400 }}>
                {todosSelecionados ? "Desmarcar todos" : "Selecionar todos"}
              </span>
              <Form.Check
                type="checkbox"
                checked={todosSelecionados}
                ref={(el) => { if (el) el.indeterminate = algumSelecionado; }}
                onChange={toggleTodos}
                onClick={(e) => e.stopPropagation()}
                style={{ pointerEvents: "none" }}
              />
            </div>

            {grupos.map((grupo) => (
              <div key={grupo.id} style={estiloCard} onClick={() => toggleGrupo(grupo.id)}>
                <span style={estiloNome}>{grupo.descricao}</span>
                <Form.Check
                  type="switch"
                  checked={selecionados.has(grupo.id)}
                  onChange={() => toggleGrupo(grupo.id)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            ))}

            {selecionados.size === 0 && grupos.length > 0 && (
              <div style={{
                marginTop: 8,
                padding: "6px 10px",
                background: "var(--bs-warning-bg-subtle, #fff9e6)",
                border: "1px solid var(--bs-warning-border-subtle, #fcd34d)",
                borderRadius: 6,
                fontSize: "0.78rem",
                color: "var(--bs-warning-text-emphasis, #92400e)",
              }}>
                Nenhum grupo selecionado — nenhum grupo terá acesso aos documentos desta empresa.
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer
        className="modal-footer-padrao"
        style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)" }}
      >
        <div className="modal-footer-acoes-direita">
          <Button variant="outline-secondary" size="sm" onClick={handleClose} disabled={salvando}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            className="modal-footer-btn-salvar"
            onClick={handleSalvar}
            disabled={salvando || carregando}
          >
            {salvando ? <><Spinner animation="border" size="sm" className="me-1" />Salvando...</> : "Salvar"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default GruposAcessoEmpresasModal;
